import { API_ENDPOINTS } from "../constants/endpoints";
import api from "../lib/axios";

export const getCountryList = () => {
  return api.get(API_ENDPOINTS.COUNTRY.GET_COUNTRY_LIST);
};

export const getCountryDetails = (countryCode: string) => {
  return api.get(
    `${API_ENDPOINTS.COUNTRY.GET_COUNTRY_LIST}?countryCode=${countryCode}`
  );
};

export const getHeroTableData = (countryId: string) => {
  return api.get(`${API_ENDPOINTS.COUNTRY.GET_HERO_TABLE_DATA}/${countryId}`);
};

export const getKeyPolicyData = (countryId: string) => {
  return api.get(`${API_ENDPOINTS.COUNTRY.GET_KEY_POLICY_DATA}`);
};

export const getCountryConfigDetails = (countryId: string) => {
  return api.get(
    `${API_ENDPOINTS.COUNTRY.GET_COUNTRY_CONFIG_DETAILS}/${countryId}`
  );
};
